import { ProtectedRoutes } from 'types/Routes';

const STORAGE_KEY = 'nova_worksheet_dashboard_return_params';

/**
 * Persist current dashboard search params so breadcrumbs on child pages
 * (worksheet, class detail) can link back with the same tab/filters.
 */
export const setWorksheetDashboardReturnParams = (searchParams: URLSearchParams): void => {
  const str = searchParams.toString();
  if (str) {
    window.sessionStorage.setItem(STORAGE_KEY, str);
  } else {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
};

/**
 * Path for the "Arbeitsblatt-Verwaltung" breadcrumb, including any
 * previously persisted dashboard params so the user returns to the same state.
 */
export const getWorksheetDashboardBreadcrumbPath = (): string => {
  const params = window.sessionStorage.getItem(STORAGE_KEY);
  if (!params) return ProtectedRoutes.WORKSHEET_DASHBOARD;
  return `${ProtectedRoutes.WORKSHEET_DASHBOARD}?${params}`;
};
